import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { ArrowLeft, Flame } from "lucide-react";

export default function Streak() {
  const nav = useNavigate();
  const [s, setS] = useState({ current: 0, best: 0 });

  useEffect(() => {
    api.get("/streak").then((r) => setS(r.data));
  }, []);

  return (
    <div className="min-h-screen" data-testid="streak-screen">
      <div className="max-w-md mx-auto px-6 pt-8">
        <div className="flex items-center gap-3 mb-7">
          <button onClick={() => nav(-1)} className="p-2 rounded-full hover:bg-white/70" data-testid="streak-back">
            <ArrowLeft className="w-5 h-5"/>
          </button>
          <h1 className="font-display text-3xl">Streak</h1>
        </div>

        <div className="card-elevated p-8 text-center">
          <Flame className="w-12 h-12 mx-auto text-[hsl(var(--neu-orange))]"/>
          <div className="font-display text-7xl mt-4">{s.current}</div>
          <div className="text-sm text-muted-foreground">weeks in a row</div>
          <div className="mt-6 pt-6 border-t flex items-center justify-around">
            <div>
              <div className="font-display text-2xl">{s.best}</div>
              <div className="text-xs text-muted-foreground">Best streak</div>
            </div>
            <div>
              <div className="font-display text-2xl">{s.last_completed_iso_week || "-"}</div>
              <div className="text-xs text-muted-foreground">Last completed</div>
            </div>
          </div>
        </div>

        <p className="text-center text-sm text-muted-foreground mt-6">
          Complete one session every Sunday to keep your streak alive.
        </p>
      </div>
    </div>
  );
}
